


























































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  ShopSpecialRefundPreview,
  ShopSpecialRefundExecute,
  ShopSpecialRefundPreviewExecuteItem,
  ShopSpecialRefundPreviewRollback,
  ShopSpecialRefundRollback,
  ShopSpecialRefundQueryBatch,
  ShopSpecialRefundListBatch,
  ShopSpecialRefundListExecSuccess,
  ShopSpecialRefundListOperateLog,
  ShopSpecialRefundQueryBatchItemDetail,
  ShopSpecialRefundListUserLogByBatch,
  ShopSpecialRefundQueryPlatformLossAnalysis,
  ExportShopSpecialRefundPreviewExcel,
  ExportShopSpecialRefundResultExcel,
  ExportShopSpecialRefundRollbackExcel,
  ExportShopSpecialRefundExecSuccessExcel
} from '@/api'
import { PriceFormat } from '@/utils/tyepconvert'
import { DateFormat } from '@/utils/date/DateUtil'

const MATCH_LABEL: Record<string, string> = {
  REFUNDABLE: '余额可退',
  SKIP_WITHDRAW: '已提现占用',
  SKIP_BALANCE: '余额不足',
  SKIP_UNSETTLED: '待结算不退'
}

const BATCH_STATUS: Record<number, string> = {
  0: '预估',
  1: '执行中',
  2: '完成',
  3: '部分失败',
  4: '已回滚',
  5: '回滚失败'
}

const EXEC_STATUS: Record<number, string> = {
  0: '待执行',
  1: '成功',
  2: '失败',
  3: '跳过',
  4: '已回滚',
  5: '回滚失败'
}

const CHANGE_SCENE: Record<string, string> = {
  BUYER_REFUND: '退买家绿豆',
  COMMISSION_CLAWBACK: '冲销分佣',
  COMMISSION_REFERENCE: '分佣参考',
  MUNG_BEAN_LOSS: '代理绿豆亏损'
}

@Component
export default class ShopSpecialRefund extends Vue {
  private pageTab = 'operate'
  private detailTab = 'orders'
  private shopId = ''
  private refundRecipientUserId = ''
  private remark = ''
  private activeTab = 'ALL'
  private loadingPreview = false
  private loadingLoss = false
  private lossAnalysisLoaded = false
  private executing = false
  private executingSingle = false
  private executingSelected = false
  private selectedRows: any[] = []
  private executeOrderCode = ''
  private rolling = false
  private rollbackDialogVisible = false
  private batch: any = {}
  private lossAnalysis: any = {}
  private rollbackPreview: any = { checks: [] }

  private batchList: any[] = []
  private batchListTotal = 0
  private batchListPage = 1
  private batchListLoading = false
  private batchQuery: any = { shopId: '', batchNo: '', status: null, limit: 10, createTimeDaterange: null }
  private batchStatusOptions = [
    { label: '预估', value: 0 },
    { label: '执行中', value: 1 },
    { label: '完成', value: 2 },
    { label: '部分失败', value: 3 },
    { label: '已回滚', value: 4 },
    { label: '回滚失败', value: 5 }
  ]

  private execSuccessList: any[] = []
  private execSuccessTotal = 0
  private execSuccessPage = 1
  private execSuccessLoading = false
  private execSuccessQuery: any = {
    shopId: '',
    userId: '',
    batchNo: '',
    recordStatus: 1,
    limit: 20,
    execTimeDaterange: null
  }

  private operateLogList: any[] = []
  private operateLogTotal = 0
  private operateLogPage = 1
  private operateLogLoading = false
  private operateLogQuery: any = {
    shopId: '',
    userId: '',
    batchNo: '',
    operateType: '',
    limit: 20,
    createTimeDaterange: null
  }
  private operateTypeOptions = [
    { label: '预估', value: 'PREVIEW' },
    { label: '执行前预览', value: 'PREVIEW_EXECUTE' },
    { label: '执行单笔', value: 'EXECUTE_ONE' },
    { label: '批量执行', value: 'EXECUTE_BATCH' },
    { label: '整批回滚', value: 'ROLLBACK' }
  ]

  private userLogList: any[] = []
  private userLogTotal = 0
  private userLogPage = 1
  private userLogLimit = 20
  private userLogPhase: number | null = null
  private userLogUserId = ''
  private userLogOrderCode = ''
  private userLogLoading = false

  private itemDetailVisible = false
  private itemDetail: any = {}
  private itemDetailPhase: number | null = null
  private itemDetailOrderCode = ''

  private executePreviewVisible = false
  private executePreviewLoading = false
  private executePreview: any = {}
  private pendingExecuteOrderCode = ''
  private pendingExecuteRecipientId: number | null = null

  public created() {
    this.applyRouteShopId()
  }

  @Watch('$route.query.shopId')
  private onRouteShopIdChange() {
    this.applyRouteShopId()
  }

  private applyRouteShopId() {
    const q = this.$route.query.shopId
    if (q != null && String(q).trim() !== '') {
      this.shopId = String(q).trim()
      this.pageTab = 'operate'
    }
  }

  private get filteredItems() {
    const items = this.batch.items || []
    if (this.activeTab === 'ALL') return items
    return items.filter((e: any) => e.matchType === this.activeTab)
  }

  private get skipWithdrawCount() {
    const items = this.batch.items || []
    return items.filter((e: any) => e.matchType === 'SKIP_WITHDRAW').length
  }

  private get showWithdrawOccupyRemark() {
    return this.activeTab === 'SKIP_WITHDRAW' || this.activeTab === 'ALL'
  }

  private get batchStatusForExecute() {
    const st = this.batch.status
    return st == null || st === undefined ? 0 : Number(st)
  }

  private get canExecuteSingle() {
    if (!this.batch.batchNo) return false
    const st = this.batchStatusForExecute
    if (st !== 0 && st !== 3 && st !== 4 && st !== 2) return false
    if (st === 0 && !this.isBatchExecutable) return false
    return !!(this.executeOrderCode || '').trim()
  }

  private get isBatchExecutable() {
    return this.batch.executable === true || this.batch.executable === 1
  }

  private get canExecuteAll() {
    if (!this.batch.batchNo || this.executing) return false
    if (!this.isBatchExecutable) return false
    const st = this.batchStatusForExecute
    return st === 0
  }

  private get canExecuteSelected() {
    if (!this.batch.batchNo || this.executingSelected) return false
    if (!this.isBatchExecutable) return false
    const st = this.batchStatusForExecute
    if (st !== 0 && st !== 3 && st !== 4 && st !== 2) return false
    return this.selectedRows.some((r: any) => this.canExecuteRow(r))
  }

  private rowSelectable(row: any) {
    return this.canExecuteRow(row)
  }

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows || []
  }

  private buildPreviewPayload() {
    const payload: any = { shopId: Number(this.shopId), remark: this.remark }
    const rid = (this.refundRecipientUserId || '').trim()
    if (rid) payload.refundRecipientUserId = Number(rid)
    return payload
  }

  private get pendingRefundableCount() {
    return (this.batch.items || []).filter((e: any) =>
      e.matchType === 'REFUNDABLE' && (e.execStatus === 0 || e.execStatus == null)
    ).length
  }

  private canExecuteRow(row: any) {
    const st = this.batchStatusForExecute
    if (st !== 0 && st !== 3 && st !== 4 && st !== 2) return false
    if (st === 0 && !this.isBatchExecutable) return false
    return row.matchType === 'REFUNDABLE'
      && (row.execStatus === 0 || row.execStatus == null || row.execStatus === 4
        || (row.execStatus === 1 && row.refundEffective === false))
  }

  private validateExecuteOrder(code: string): string | null {
    const item = (this.batch.items || []).find((e: any) => e.orderCode === code)
    if (!item) {
      return `订单不在本批次明细中：${code}，请核对订单号或在「全部」Tab 查看分类`
    }
    if (item.matchType !== 'REFUNDABLE') {
      return `订单分类为「${this.matchTypeFormat(null, null, item.matchType)}」，非余额可退，无法执行`
    }
    if (item.execStatus === 1 && item.refundEffective !== false) return `订单已执行成功：${code}`
    if (item.execStatus === 2) return `订单执行失败，请重新预估后再试：${code}`
    if (item.execStatus === 5) return `订单回滚失败，请联系技术处理：${code}`
    return null
  }

  @Watch('batch.batchNo')
  private onBatchNoChange() {
    if (this.batch.batchNo && this.detailTab === 'userLogs') {
      this.loadUserLogs()
    }
  }

  @Watch('detailTab')
  private onDetailTabChange(val: string) {
    if (val === 'userLogs' && this.batch.batchNo) {
      this.userLogPage = 1
      this.loadUserLogs()
    }
  }

  private onPageTabChange() {
    if (this.pageTab === 'batchList') {
      this.loadBatchList()
    } else if (this.pageTab === 'execSuccess') {
      this.loadExecSuccessList()
    } else if (this.pageTab === 'operateLog') {
      this.loadOperateLogList()
    }
  }

  private buildTimeScopeParam(daterange: any[] | null, fieldName: string, param: any) {
    if (daterange && daterange.length === 2) {
      param[fieldName] = DateFormat(daterange[0]) + ',' + DateFormat(daterange[1])
    }
  }

  private matchTypeFormat(row: any, _col: any, val: string) {
    if (row && row.matchTypeLabel) return row.matchTypeLabel
    return MATCH_LABEL[val] || val
  }

  private matchTypeTagType(row: any) {
    if (!row) return ''
    if (row.withdrawOccupiedPartial) return 'warning'
    if (row.matchType === 'SKIP_WITHDRAW') return 'info'
    if (row.matchType === 'REFUNDABLE') return 'success'
    if (row.matchType === 'SKIP_BALANCE') return 'danger'
    return ''
  }

  private withdrawOccupiedFormat(row: any, _col: any, val: number) {
    if (val == null) return '-'
    const base = String(val)
    if (row && row.withdrawOccupiedPartial && row.shopDeductFen != null) {
      return `${base}（部分/${row.shopDeductFen}）`
    }
    return base
  }

  private execStatusFormat(row: any, _col: any, val: number) {
    if (row && row.execStatusLabel) return row.execStatusLabel
    return EXEC_STATUS[val] || String(val)
  }

  private changeSceneFormat(_row: any, _col: any, val: string) {
    return CHANGE_SCENE[val] || val
  }

  private boolFormat(_row: any, _col: any, val: boolean) {
    return val ? '是' : '否'
  }

  private batchStatusFormat(_row: any, _col: any, val: number) {
    return BATCH_STATUS[val] || String(val)
  }

  private phaseFormat(_row: any, _col: any, val: number) {
    if (val === 1) return '预估'
    if (val === 2) return '执行'
    if (val === 3) return '回滚'
    return val
  }

  private wealthTypeFormat(_row: any, _col: any, val: number) {
    if (val === 1) return '贡献'
    if (val === 2) return '能量'
    if (val === 3) return '绿豆'
    return val
  }

  private dateTimeFormat(_row: any, _col: any, val: string | Date) {
    if (!val) return '-'
    const d = val instanceof Date ? val : new Date(val)
    if (Number.isNaN(d.getTime())) return String(val)
    const pad = (n: number) => (n < 10 ? '0' + n : String(n))
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  }

  private async doPreview() {
    if (!this.shopId) {
      this.$message.warning('请输入店铺ID')
      return
    }
    this.loadingPreview = true
    try {
      const data = await ShopSpecialRefundPreview(this.buildPreviewPayload())
      if (!data) return
      this.batch = data
      this.rollbackPreview = { checks: [] }
      this.selectedRows = []
      const skipWithdraw = (data.items || []).filter((e: any) => e.matchType === 'SKIP_WITHDRAW')
      this.activeTab = (data.refundableCount || 0) > 0 ? 'REFUNDABLE' : (skipWithdraw.length > 0 ? 'SKIP_WITHDRAW' : 'ALL')
      this.detailTab = 'orders'
      this.$nextTick(() => {
        const table = this.$refs.orderTable as any
        if (table && table.clearSelection) table.clearSelection()
      })
      const msg = data.message || ''
      if ((data.refundableCount || 0) === 0 && skipWithdraw.length > 0) {
        this.$message.warning(msg || '无可退订单，请查看「已提现占用」Tab')
      } else {
        this.$message.success('预估完成：' + (this.batch.batchNo || '') + '，请在「可退」Tab 勾选订单后执行')
      }
    } finally {
      this.loadingPreview = false
    }
  }

  private fenYuan(fen: number | null | undefined) {
    return PriceFormat(fen || 0)
  }

  private fenColFormat(_row: any, _col: any, val: number) {
    return PriceFormat(val || 0)
  }

  private async doLossAnalysis() {
    this.loadingLoss = true
    try {
      const data = await ShopSpecialRefundQueryPlatformLossAnalysis()
      if (!data) return
      this.lossAnalysis = data
      this.lossAnalysisLoaded = true
      this.$message.success('全平台亏损测算完成')
      this.$nextTick(() => {
        const panel = this.$refs.lossPanel as HTMLElement | undefined
        if (panel && panel.scrollIntoView) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    } finally {
      this.loadingLoss = false
    }
  }

  private async reloadBatch() {
    if (!this.batch.batchNo) return
    const data = await ShopSpecialRefundQueryBatch({ batchNo: this.batch.batchNo })
    if (data) this.batch = data
  }

  private searchBatchList() {
    this.batchListPage = 1
    this.loadBatchList()
  }

  private async loadBatchList() {
    this.batchListLoading = true
    try {
      const param: any = {
        startRow: (this.batchListPage - 1) * this.batchQuery.limit,
        limit: this.batchQuery.limit
      }
      if (this.batchQuery.shopId) param.shopId = Number(this.batchQuery.shopId)
      if (this.batchQuery.batchNo) param.batchNo = this.batchQuery.batchNo
      if (this.batchQuery.status != null && this.batchQuery.status !== '') param.status = this.batchQuery.status
      this.buildTimeScopeParam(this.batchQuery.createTimeDaterange, 'createTimes', param)
      const res = await ShopSpecialRefundListBatch(param)
      if (!res) return
      this.batchList = res.list || []
      this.batchListTotal = res.total || 0
    } finally {
      this.batchListLoading = false
    }
  }

  private async selectBatchFromList(row: any) {
    this.pageTab = 'operate'
    this.shopId = String(row.shopId || '')
    const data = await ShopSpecialRefundQueryBatch({ batchNo: row.batchNo })
    if (data) {
      this.batch = data
      this.rollbackPreview = { checks: [] }
    }
  }

  private searchExecSuccessList() {
    this.execSuccessPage = 1
    this.loadExecSuccessList()
  }

  private async loadExecSuccessList() {
    this.execSuccessLoading = true
    try {
      const param: any = {
        startRow: (this.execSuccessPage - 1) * this.execSuccessQuery.limit,
        limit: this.execSuccessQuery.limit
      }
      if (this.execSuccessQuery.shopId) param.shopId = Number(this.execSuccessQuery.shopId)
      if (this.execSuccessQuery.userId) param.userId = Number(this.execSuccessQuery.userId)
      if (this.execSuccessQuery.batchNo) param.batchNo = this.execSuccessQuery.batchNo
      if (this.execSuccessQuery.recordStatus != null && this.execSuccessQuery.recordStatus !== '') {
        param.recordStatus = this.execSuccessQuery.recordStatus
      }
      this.buildTimeScopeParam(this.execSuccessQuery.execTimeDaterange, 'execTimes', param)
      const res = await ShopSpecialRefundListExecSuccess(param)
      if (!res) return
      this.execSuccessList = res.list || []
      this.execSuccessTotal = res.total || 0
    } finally {
      this.execSuccessLoading = false
    }
  }

  private exportExecSuccess() {
    const param: any = {}
    if (this.execSuccessQuery.shopId) param.shopId = Number(this.execSuccessQuery.shopId)
    if (this.execSuccessQuery.userId) param.userId = Number(this.execSuccessQuery.userId)
    if (this.execSuccessQuery.batchNo) param.batchNo = this.execSuccessQuery.batchNo
    if (this.execSuccessQuery.recordStatus != null && this.execSuccessQuery.recordStatus !== '') {
      param.recordStatus = this.execSuccessQuery.recordStatus
    }
    this.buildTimeScopeParam(this.execSuccessQuery.execTimeDaterange, 'execTimes', param)
    ExportShopSpecialRefundExecSuccessExcel(param, '特殊关单执行成功明细.xlsx')
  }

  private searchOperateLogList() {
    this.operateLogPage = 1
    this.loadOperateLogList()
  }

  private async loadOperateLogList() {
    this.operateLogLoading = true
    try {
      const param: any = {
        startRow: (this.operateLogPage - 1) * this.operateLogQuery.limit,
        limit: this.operateLogQuery.limit
      }
      if (this.operateLogQuery.shopId) param.shopId = Number(this.operateLogQuery.shopId)
      if (this.operateLogQuery.userId) param.userId = Number(this.operateLogQuery.userId)
      if (this.operateLogQuery.batchNo) param.batchNo = this.operateLogQuery.batchNo
      if (this.operateLogQuery.operateType) param.operateType = this.operateLogQuery.operateType
      this.buildTimeScopeParam(this.operateLogQuery.createTimeDaterange, 'createTimes', param)
      const res = await ShopSpecialRefundListOperateLog(param)
      if (!res) return
      this.operateLogList = res.list || []
      this.operateLogTotal = res.total || 0
    } finally {
      this.operateLogLoading = false
    }
  }

  private async openItemDetail(row: any) {
    if (!this.batch.batchNo || !row.orderCode) return
    this.itemDetailOrderCode = row.orderCode
    this.itemDetailPhase = null
    await this.reloadItemDetail()
    this.itemDetailVisible = true
  }

  private async reloadItemDetail() {
    const data = await ShopSpecialRefundQueryBatchItemDetail({
      batchNo: this.batch.batchNo,
      orderCode: this.itemDetailOrderCode,
      logPhase: this.itemDetailPhase
    })
    if (data) this.itemDetail = data
  }

  private async loadUserLogs() {
    if (!this.batch.batchNo) return
    this.userLogLoading = true
    try {
      const param: any = {
        batchNo: this.batch.batchNo,
        startRow: (this.userLogPage - 1) * this.userLogLimit,
        limit: this.userLogLimit
      }
      if (this.userLogPhase != null) param.logPhase = this.userLogPhase
      if (this.userLogUserId) param.userId = Number(this.userLogUserId)
      if (this.userLogOrderCode) param.orderCode = this.userLogOrderCode
      const res = await ShopSpecialRefundListUserLogByBatch(param)
      if (!res) return
      this.userLogList = res.list || []
      this.userLogTotal = res.total || 0
    } finally {
      this.userLogLoading = false
    }
  }

  private exportPreview() {
    ExportShopSpecialRefundPreviewExcel({ batchNo: this.batch.batchNo }, `特殊关单预估_${this.batch.batchNo}.xlsx`)
  }

  private exportResult() {
    ExportShopSpecialRefundResultExcel({ batchNo: this.batch.batchNo }, `特殊关单执行_${this.batch.batchNo}.xlsx`)
  }

  private exportRollback() {
    ExportShopSpecialRefundRollbackExcel({ batchNo: this.batch.batchNo }, `特殊关单回滚_${this.batch.batchNo}.xlsx`)
  }

  private doExecuteAll() {
    if (!this.canExecuteAll) {
      const st = this.batchStatusForExecute
      if (!this.isBatchExecutable) {
        this.$message.warning(this.batch.message || '当前批次不可执行，请查看提示或重新预估')
      } else if (st !== 0) {
        this.$message.warning('仅「预估」状态批次可整批执行；部分执行后请用「执行此单」逐笔处理')
      }
      return
    }
    if (this.pendingRefundableCount <= 0) {
      this.$message.warning('本批次无可退待执行订单')
      return
    }
    this.doExecute()
  }

  private async doExecute(orderCode?: string, orderCodes?: string[], refundRecipientUserId?: number | null, skipConfirm = false) {
    const codes = orderCodes && orderCodes.length
      ? orderCodes
      : (typeof orderCode === 'string' && orderCode.trim() ? [orderCode.trim()] : [])
    const isPartial = codes.length > 0
    if (!skipConfirm) {
      const msg = isPartial
        ? `确认执行 ${codes.length} 笔订单的特殊关单退绿豆？\n${codes.join('\n')}`
        : `确认执行本批次全部 ${this.pendingRefundableCount} 笔「余额可退」订单？此操作与现网退款隔离。`
      try {
        await this.$confirm(msg, isPartial ? '执行选中/指定单' : '确认执行全部可退', { type: 'warning' })
      } catch {
        return
      }
    }
    const isSingle = codes.length === 1
    if (isSingle) {
      this.executingSingle = true
    } else if (isPartial) {
      this.executingSelected = true
    } else {
      this.executing = true
    }
    try {
      const param: any = { batchNo: this.batch.batchNo }
      if (codes.length === 1) {
        param.orderCode = codes[0]
      } else if (codes.length > 1) {
        param.orderCodes = codes
      }
      if (refundRecipientUserId != null) {
        param.refundRecipientUserId = refundRecipientUserId
      }
      const data = await ShopSpecialRefundExecute(param, !isSingle && codes.length <= 1)
      if (!data) return
      this.$message.success(data.message || '执行完成')
      this.executePreviewVisible = false
      await this.reloadBatch()
    } finally {
      this.executing = false
      this.executingSingle = false
      this.executingSelected = false
    }
  }

  private doExecuteSelected() {
    const codes = this.selectedRows
      .filter((r: any) => this.canExecuteRow(r))
      .map((r: any) => r.orderCode)
    if (!codes.length) {
      this.$message.warning('请先勾选可退订单')
      return
    }
    this.doExecute(undefined, codes)
  }

  private doExecuteSingle() {
    const code = (this.executeOrderCode || '').trim()
    if (!code) {
      this.$message.warning('请输入订单号')
      return
    }
    const err = this.validateExecuteOrder(code)
    if (err) {
      this.$message.warning(err)
      return
    }
    this.doExecute(code)
  }

  private async doExecuteOne(row: any) {
    if (!row || !row.orderCode) return
    this.executeOrderCode = row.orderCode
    const err = this.validateExecuteOrder(row.orderCode)
    if (err) {
      this.$message.warning(err)
      return
    }
    const defaultRecipient = row.refundRecipientUserId
      || this.batch.refundRecipientUserId
      || row.buyerUserId
      || ''
    let recipientInput = ''
    try {
      const res: any = await this.$prompt(
        '请输入退绿豆接收人用户ID（留空则退下单人）',
        '执行此单 - ' + row.orderCode,
        {
          confirmButtonText: '下一步',
          cancelButtonText: '取消',
          inputValue: defaultRecipient ? String(defaultRecipient) : '',
          inputPlaceholder: '空则退下单人'
        }
      )
      recipientInput = (res.value || '').trim()
    } catch {
      return
    }
    let recipientId: number | null = null
    if (recipientInput) {
      recipientId = Number(recipientInput)
      if (!recipientId || Number.isNaN(recipientId)) {
        this.$message.warning('接收人ID须为数字')
        return
      }
    }
    this.pendingExecuteOrderCode = row.orderCode
    this.pendingExecuteRecipientId = recipientId
    this.executePreview = {}
    this.executePreviewVisible = true
    this.executePreviewLoading = true
    try {
      const payload: any = {
        batchNo: this.batch.batchNo,
        orderCode: row.orderCode
      }
      if (recipientId != null) {
        payload.refundRecipientUserId = recipientId
      }
      const data = await ShopSpecialRefundPreviewExecuteItem(payload)
      if (!data) {
        this.executePreviewVisible = false
        return
      }
      this.executePreview = data
    } finally {
      this.executePreviewLoading = false
    }
  }

  private confirmExecutePreview() {
    if (!this.pendingExecuteOrderCode) return
    if (!this.executePreview.fundSufficient) {
      this.$message.warning('店铺资金不足，无法执行')
      return
    }
    this.doExecute(this.pendingExecuteOrderCode, undefined, this.pendingExecuteRecipientId, true)
  }

  private async doPreviewRollback() {
    const data = await ShopSpecialRefundPreviewRollback({ batchNo: this.batch.batchNo })
    if (!data) return
    this.rollbackPreview = data
    this.rollbackDialogVisible = true
  }

    private async doRollback() {
    await this.$confirm('确认整批回滚？将扣回已退买家绿豆、恢复店铺结算并恢复订单快照。误点会导致用户看不到退款效果。', '确认回滚', { type: 'warning' })
    this.rolling = true
    try {
      const data = await ShopSpecialRefundRollback({ batchNo: this.batch.batchNo, rollbackRemark: '后台整批回滚' })
      if (!data) return
      this.$message.success(data.message || '回滚完成')
      this.rollbackDialogVisible = false
      await this.reloadBatch()
    } finally {
      this.rolling = false
    }
  }
}
